import { isArray } from '../../utils/customMethods'

const initialState = {
  conversations: {},
  messages: {},
}

export default function historyReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_ALL_CONVERSATION_HISTORY':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.consumerId]: { ...action.payload.data },
        },
      }
    case 'SET_CONVERSATION_HISTORY':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.consumerId]: {
            ...state.conversations[action.payload.consumerId],
            ...action.payload.data,
          },
        },
      }
    case 'SET_CONVERSATION_HISTORY_PROTOCOL':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.consumerId]: {
            [action.payload.data.conversationId]: {
              ...action.payload.data,
              isResearched: true,
            },
            ...state.conversations[action.payload.consumerId],
          }
        }
      }
    case 'DELETE_CONVERSATION_HISTORY':
      delete state.conversations[action.payload]
      return state
    case 'DELETE_ALL_CONVERSATION_HISTORY':
      return initialState
    case 'SET_MESSAGES_HISTORY': {
      const consumerId = action.payload.consumerId
      const chatId = action.payload.chatId
      const newMsgs = action.payload.data
      const msgs = consumerId && chatId && state.messages[chatId]

      return {
        ...state,
        messages: {
          ...state.messages,
          [chatId]:
            msgs?.length > 0
              ? newMsgs.length > 0
                ? [...newMsgs.reverse(), ...msgs]
                : [...msgs, { type: 'eof' }]
              : newMsgs?.reverse() ?? [],
        },
      }
    }
    case 'DELETE_MESSAGES_HISTORY':
      delete state[action.payload]
      return initialState
    default:
      return state
  }
}
